import React from 'react';
import {Divider, Form, Icon, Popconfirm} from 'antd';
import {ActionsBase} from "./ActionsBase";

class ActionsEditApp extends ActionsBase {

    customButtons(key, id) {
        const actionDeleteLink =
            <Popconfirm title="Borrar esta acción?" onConfirm={() => {this.deleteAction(this.state.action)}} cancelText="Cancelar">
                <a href="#delete"><Icon type="delete" theme="twoTone"/></a>
            </Popconfirm>;
        return <div>
            <span onClick={(e) => this.showDrawer()} key={"edit" + key}>
                    <a href="#edit">
                        <Icon type="edit" theme="twoTone"/>
                    </a>
            </span>
            <Divider type="vertical"/>
            {actionDeleteLink}
        </div>
    }
}

const ActionsEdit = Form.create()(ActionsEditApp);
export default ActionsEdit;


// WEBPACK FOOTER //
// ./src/app/views/actions/ActionsEdit.js